import React, { useState } from 'react'
import { Box, Pagination, Fab } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Base from '../Components/Base'
import BooksFilterBar from '../Components/BooksFilterBar'
import BooksGrid from '../Components/BooksGrid'
import BookFormDialog from '../Components/BookFormDialog'
import { useBooks } from '../hooks/useBooks'

function MyBooks() {
  const [viewMode, setViewMode] = useState('default')
  const {
    books,
    sortBy,
    setSortBy,
    order,
    setOrder,
    page,
    setPage,
    totalPages,
    search,
    setSearch,
    clearSearch,
    refresh,
    setRefresh,
    ratings,
    setRatings,
  } = useBooks({ viewMode })

  const [openForm, setOpenForm] = useState(false)
  const [editBook, setEditBook] = useState(null)
  const [isSeriesSelected, setIsSeriesSelected] = useState(false)

  const handleAddBook = () => {
    setEditBook(null)
    setOpenForm(true)
  }

  const handleEditBook = (book) => {
    setEditBook(book)
    setOpenForm(true)
  }

  return (
    <Base>
      <BooksFilterBar
        title="Mes livres"
        search={search}
        onSearchChange={setSearch}
        onSearchClear={() => setSearch('')}
        sortBy={sortBy}
        onSortChange={setSortBy}
        order={order}
        onOrderChange={setOrder}
        filterValues={ratings}
        onFilterChange={setRatings}
        filterIconType="heart"
        viewMode={viewMode}
        onViewModeChange={setViewMode}
        showManageSeries={true}
      />

      <BooksGrid books={books} refresh={refresh} setRefresh={setRefresh} onEdit={handleEditBook} viewMode={viewMode} onSeriesSelect={setIsSeriesSelected} />

      <BookFormDialog 
        open={openForm} 
        onClose={() => setOpenForm(false)} 
        book={editBook} 
        type="myBooks" 
        onSuccess={() => setRefresh(true)} 
      />

      {totalPages > 0 && viewMode !== 'series' && !isSeriesSelected && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 3,
            mb: 2,
          }}
        >
          <Pagination
            count={Math.max(1, totalPages)}
            page={page + 1}
            onChange={(_, value) => setPage(value - 1)}
            color="primary"
            shape="rounded"
            siblingCount={1}
            boundaryCount={1}
            size="small"
            showFirstButton
            showLastButton
          />
        </Box>
      )}

      <Fab
        color="primary"
        aria-label="ajouter un livre"
        onClick={handleAddBook}
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          zIndex: 1000,
        }}
      >
        <AddIcon />
      </Fab>
    </Base>
  )
}

export default MyBooks